import type { FC } from 'react';
import { Card, CardGroup, Selectable, SelectableItem } from '@george-labs.com/design-system';

import { HeadingSkeleton } from './HeadingSkeleton';
import { ProductInfoSkeleton } from './ProductInfoSkeleton';

const DEFAULT_NUMBER_OF_ACCOUNTS = 3;

interface Props {
    numberOfAccounts?: number;
    'data-cy'?: string;
}

export const SelectAccountSkeleton: FC<Props> = ({
    numberOfAccounts = DEFAULT_NUMBER_OF_ACCOUNTS,
    'data-cy': dataCy,
}) => {
    return (
        <>
            <HeadingSkeleton />
            <CardGroup data-cy={dataCy}>
                <Selectable
                    type={Selectable.TYPE.RADIO}
                    verticalAlign={Selectable.VERTICAL_ALIGN.MIDDLE}
                    selectedItems={['']}
                    disableUncheckedItems
                >
                    {[...Array(numberOfAccounts).keys()].map((index) => (
                        <Card key={`card_${index + 1}`}>
                            <SelectableItem disabled value="">
                                <ProductInfoSkeleton />
                            </SelectableItem>
                        </Card>
                    ))}
                </Selectable>
            </CardGroup>
        </>
    );
};
